module.exports = __webpack_public_path__ + "img/UIUX.f8dac3fd.svg";